const Textarea = ({
  placeholder,
  label,
  row,
  value,
  onChange,
  classNameTextarea,
  classNameLabel,
}) => {
  return (
    <div className="flex flex-col">
      <label
        className={`text-sm font-semibold text-gray-800 mb-1 ${classNameLabel}`}
      >
        {label}
      </label>
      <textarea
        rows={row}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`p-2 resize-none h-16 text-sm text-gray-900 border border-gray-300 rounded focus:outline-none ${classNameTextarea}`}
      />
    </div>
  );
};

export default Textarea;
